export const environment = {
  production: false,
  api: 'https://admin.marbleslostandfound.co.uk/api'
};

